<template>
    <v-btn icon="mdi-home" size="small" class="bg-grey-lighten-4" variant="tonal" @click="goHome"></v-btn>
</template>

<script>
export default {
    name: 'HomeButton',
    methods: {
        goHome() {
            this.$router.push('/')
        }
    }
}
</script>